import Choices from "../../_snowpack/pkg/choicesjs.js";
export const customizeDropdown = () => {
  document.querySelectorAll("select").forEach(function(dropdown) {
    const customizedDropdown = new Choices(dropdown, {
      searchEnabled: false,
      shouldSort: false
    });
  });
};
customizeDropdown();
